import { Component } from '@angular/core';

@Component({
  selector: 'app-basic-layout',
  templateUrl: './basic-layout.component.html',
  styleUrls: [
    '../full-layout/full-layout.component.css'
  ]
})

export class BasicLayoutComponent {
  constructor() { }
}
